<template src="./Header.html">
</template>

<script>
  import axios from 'axios'
  import localeSwitch from "@/components/global/LocaleSwitch.vue"
  import echosService from "@/services/echosService.js"
  import impersonationModal from "@/components/global/ImpersonationModal"

axios.defaults.headers.common['Pragma'] = 'no-cache';

export default {
  name: "mainHeader",
  components: {
    'locale-switch': localeSwitch,
    impersonationModal
  },
  data: function() {
    return {
      isActive: false,
      user: null,
      isUser: false,
      isImpersonated: false,
      isEpicImpersonated: false,
      isBpImpersonated: false,
      impersonatedUser: {},
      showUserAvatarMenu: false,
      showEpicSearchAccount: true, // moving the check for account search out to the tab itself, it leads to too many 500s in the echos logs and sometimes crashes debugger on startup.
      canSeeStats: false,
      canImpersonate: false
    };
  },
  mounted() {
    this.setUser();
    this.isUserImpersonated();
  },

  methods: {
    hamburger: _hamburgers,
    logout() {
      this.user = null;
      this.$auth.signOut();
    },
    login() {
      console.log('click')
      this.$auth.signIn();
    },
    setUser() {
      this.user = this.$auth.getUser();

      if (!this.user || !this.user.idTokenClaims) { //SPA just loaded and did not yet go thru auth cycle prevent the error in line 54
        return;
      }

      if (this.user.idTokenClaims.roles !== undefined && this.user.idTokenClaims.roles !== null)
      {
        let statsrole = this.user.idTokenClaims.roles.find((x) => { return x === "UsageStats.View"; });
        if (statsrole !== null & statsrole !== undefined) {
          this.canSeeStats = true;
        }

        let adminrole = this.user.idTokenClaims.roles.find((x) => { return x === "Impersonator"; });
        if (adminrole !== null & adminrole !== undefined) {
          this.canImpersonate = true;
        }
      }
    },
    isUserImpersonated() {
      let app = this;
      this.$refs.impersonationModal.isImpersonated();
    },
    onIsUserImpersonated(result) {
      this.isImpersonated = result.isImpersonated;
      if(this.isImpersonated){
        this.isEpicImpersonated = result.metadata.impersonateEpic;
        this.isBpImpersonated = result.metadata.impersonateBP;
      }else{
        this.isEpicImpersonated = false;
        this.isBpImpersonated = false;
      }

      this.impersonatedUser.firstName = result.userContext.firstName;
      this.impersonatedUser.lastName = result.userContext.lastName;
      this.impersonatedUser.email = result.userContext.email;
    },
    showImpersonationModal() {
      let app = this;
      this.$refs.impersonationModal.show();
      this.showUserAvatarMenu = false;
    },
    removeImpersonation() {
      let app = this;
      this.$refs.impersonationModal.unimpersonate();
      this.showUserAvatarMenu = false;
    },
    onImpersonationSuccess(firstName, lastName, email, epic, bp) {
      this.impersonatedUser.firstName = firstName;
      this.impersonatedUser.lastName = lastName;
      this.impersonatedUser.email = email;
      this.isImpersonated = true;
      this.isEpicImpersonated = epic;
      this.isBpImpersonated = bp;
      location.reload();
    },
    onRemoveImpersonation() {
      this.isImpersonated = false;
      this.isBpImpersonated = false;
      this.isEpicImpersonated = false;
      this.impersonatedUser = {};
      location.reload();
    },
  },
  computed: {
    userInitials() {
      var array1 = this.user.name.split(", ", 2);
      var newarray1 = [];

      for (var x = array1.length - 1; x >= 0; x--) {
        newarray1.push(array1[x].charAt(0).toUpperCase());
      }

      return newarray1.join("");
    },
    impersonationMessage() {
      if (this.isImpersonated)
      {
        return "Emulating: " + this.impersonatedUser.firstName + " " + this.impersonatedUser.lastName;
      }

      return "Not impersonated";
    }
  }
};

function _hamburgers() {
  this.isActive = !this.isActive;
}
</script>
